export const SETTINGS_REQUEST = 'SETTINGS_REQUEST'
export const SETTINGS_ERROR = 'SETTINGS_ERROR'
export const SETTINGS_EMPTY = 'SETTINGS_EMPTY'
export const SETTINGS_SUCCESS = 'SETTINGS_SUCCESS'
export const SETTINGS_UPDATE = 'SETTINGS_UPDATE'
export const SETTINGS_STORE = 'SETTINGS_STORE'


// export const SETTINGS_REQUEST_GUIDELINES_AND_PUBLICATION_COUNCIL = 'SETTINGS_REQUEST_GUIDELINES_AND_PUBLICATION_COUNCIL'
// export const SETTINGS_REQUEST_COMMITTEE_USERS = 'SETTINGS_REQUEST_COMMITTEE_USERS'
// export const SETTINGS_REQUEST_COMMITTEE_AND_EXTERNAL_USERS = 'SETTINGS_REQUEST_COMMITTEE_AND_EXTERNAL_USERS'

// export const SETTINGS_IMPORT = 'SETTINGS_IMPORT'
// export const SETTINGS_IMPORT_CHECK = 'SETTINGS_IMPORT_CHECK'
